var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('micro-app',{attrs:{"name":"report","url":_vm.config.microReportUrl,"baseroute":"/report","data":_vm.storeInfo,"iframe":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }